<div class="actions">
	<app-button
		appearance="secondary"
		size="s"
		[isDisabled]="openedDropdown() === dropdownVariantEnum.OPTION_INFO_ORDER"
		[tuiDropdownMinHeight]="600"
		[tuiDropdownMaxHeight]="600"
		[tuiDropdown]="infoOrderDropdown"
		[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.OPTION_INFO_ORDER"
		(clicked)="toggleDropdown(dropdownVariantEnum.OPTION_INFO_ORDER)"
	>
		{{ 'optionsOrders.info' | translate }}
	</app-button>
</div>

<ng-template #infoOrderDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-info-options-order
			[order]="option()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>
